import { FC, useCallback } from "react";
import Chip from "@mui/material/Chip";
import {
  ResourceExplorerAnomaliesInsightBreakdown,
  ResourceExplorerFilterSchema,
} from "@/services/cloudchipr.api";
import { useAppDispatch } from "@/store/hooks";
import { setExplainWithAiAnomalyTab } from "@/store/explain-with-ai/explainWithAiSlice";
import { AnomalyIcon } from "@/components/pages/resource-explorer/components/explain-with-ai-panel/components/body/anomalies/AnomalyIcon";

interface ExploreWithAIButtonV2AnomaliesTooltipTitleItemProps
  extends ResourceExplorerAnomaliesInsightBreakdown {
  onClick(mode: ResourceExplorerFilterSchema["mode"]): void;
}

export const ExploreWithAIButtonV2AnomaliesTooltipTitleItem: FC<
  ExploreWithAIButtonV2AnomaliesTooltipTitleItemProps
> = ({ total, type, onClick }) => {
  const dispatch = useAppDispatch();
  const clickHandler = useCallback(() => {
    if (!type) {
      return;
    }
    dispatch(setExplainWithAiAnomalyTab(type));
    onClick("anomaly_detector");
  }, [type, dispatch, onClick]);

  if (!type) {
    return null;
  }
  return (
    <Chip
      label={`${total} ${trendsLabels?.[type]}${(total ?? 0) > 1 ? "s" : ""}`}
      variant="outlined"
      icon={<AnomalyIcon type={type} fontSize="small" color="warning" />}
      color="warning"
      onClick={clickHandler}
      clickable
      sx={{
        p: 0.5,
      }}
    />
  );
};

const trendsLabels = {
  spikes: "Spike",
  decreaseTrends: "Decrease",
  decrease_trends: "Decrease",
  increaseTrends: "Increase",
  increase_trends: "Increase",
};
